


import React from "react";
import { Link } from "react-router-dom";
import {
  AppBar,
  Toolbar,
  IconButton,
  Tooltip,
  Container,
  Paper,
  Box,
  Menu,
  MenuItem,
} from "@mui/material";
import { useTheme, useMediaQuery } from "@mui/material";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import PersonIcon from "@mui/icons-material/Person";
import CartIcon from "./CartIcon";
import Nav from "./nav";
import Search from "./Search";
import { useDispatch, useSelector } from "react-redux";
import logo from "../assets/logo.jpg";
import ProductList from "./ProductList";
import { logoutUser } from "../features/userSlice";
import CartHoverPreview from "./CartHoverPreview";
import { useState } from "react";
import Popper from "@mui/material/Popper";
import { useNavigate } from "react-router-dom";
import { CLEAR_CART } from "../features/productInCartSlice";


export default function Header() {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("md"));
  const dispatch = useDispatch();
  const logedUser = useSelector((s) => s.user.logedUser);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const openUserMenu = Boolean(anchorEl);
  const cart = useSelector((s) => s.cart.items);
  const products = useSelector((s) => s.product.products);
  const [showCartPreview, setShowCartPreview] = useState(false);
  const [cartAnchor, setCartAnchor] = useState(null);
  const navigate = useNavigate();
  const [isCartClicking, setIsCartClicking] = useState(false);

  const handleUserIconClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleUserMenuClose = () => {
    setAnchorEl(null);
  };
const handleLogout = () => {
  dispatch(logoutUser());
  dispatch(CLEAR_CART());

  localStorage.removeItem("loggedUser");
  localStorage.removeItem("isAdmin");
  localStorage.removeItem("cart");

  handleUserMenuClose();
  navigate("/");
};



  return (
    <>
      {/* לוגו קבוע - מופרד מהסרגל, לא נגלל */}
      {/* <Box
        component="img"
        src={logo}
        alt="logo"
        sx={{
          position: "fixed",
          top: { xs: 8, md: 5 },
          right: { xs: 8, md: 15 },   // להזיז יותר ימינה – הגדילי כאן
          width: { xs: 120, md: 250 },
          height: "auto",
          zIndex: (t) => t.zIndex.appBar + 2,
          pointerEvents: "none",       // שלא יחסום קליקים על הסרגל
        }}
      /> */}

      <Box
        sx={{
          position: "fixed",
          top: { xs: 8, md: 5 },
          right: 0,
          pr: { xs: 2, md: 0 }, // להזיז יותר ימינה – הגדילי כאן
          zIndex: (t) => t.zIndex.appBar + 2,
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-end",
          gap: 1,
          width: { xs: 200, md: 420 },

        }}
      >
        {/* <Box sx={{ width: "100%" }}>
          <Box
            component="img"
            src={logo}
            alt="logo"
            sx={{
              width: { xs: 30, md: 250 },
              height: "auto",
              pointerEvents: "none", // הלוגו לא יחסום לחיצות
            }}
          />
        </Box> */}

        <Box sx={{ width: "100%" }}>
          {/* החיפוש יושב מתחת ללוגו, עם רוחב נשלט */}
          {/* <Box sx={{ width: { xs: 240, md: 420 } }}>
          <Search fromNavBar={true} />
          </Box> */}
        </Box>
      </Box>

      {/* רווח עליון כדי שלא יהיה חפיפה עם ה־fixed (כווני לפי גובה הלוגו+חיפוש) */}
      {/* <Box sx={{ height: { xs: 120 + 56, md: 250 + 64 } }} /> */}
      <AppBar
        position="sticky"
        color="transparent"
        elevation={0}
        sx={{ bgcolor: "transparent", pt: 1 }}
      >
        <Container maxWidth={false} disableGutters>
          {/* שורה אחת: לוגו + הסרגל המעוגל */}
          <Box sx={{ width: "min(1400px, 100%)", mx: "auto", px: 2 }}>
            {/* הלוגו מחוץ לסרגל */}
            {/* <Box
            component="img"
            src={logo}
            alt="logo"
            sx={{ width: 160, height: 100, display: "block" }}
          /> */}

            {/* הסרגל המעוגל */}
            <Paper
              elevation={6}
              sx={{
                flex: 1,
                borderRadius: 6,
                bgcolor: "#fff",
                overflow: "hidden",
              }}
            >
              <Toolbar
                disableGutters
                sx={{
                  px: { xs: 1, sm: 2 },
                  gap: { xs: 1, sm: 2 },
                  flexwrap: "wrap",
                  justifyContent: "space-between",
                  minHeight: { xs: 48, sm: 56, md: 64 }, // סרגל קטן יותר
                  transition: "min-height 0.3s ease",
                }}
              >
                {/* חיפוש + ניווט + אייקונים כרגיל */}
                {/* <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Search fromNavBar={true} />
              </Box> */}

                <Box sx={{ flex: 1, display: "flex", justifyContent: "center" }}>
                  {/* <Nav /> */}
                  <ProductList></ProductList>
                </Box>

                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  {logedUser?.tipeUser === "admin" && (
                    <Tooltip title="מנהל מערכת">
                      <Link to="/admin" style={{ color: "inherit" }}>
                        <AdminPanelSettingsIcon style={{ fontSize: 36 }} />
                      </Link>
                    </Tooltip>
                  )}
                  {logedUser ? (
                    <>
                      <Tooltip title={logedUser?.name ? `שלום, ${logedUser.name}` : "החשבון שלי"}>
                        <IconButton color="inherit" onClick={handleUserIconClick}>
                          <PersonIcon style={{ fontSize: 36, color: "#58A76B" }} />
                        </IconButton>
                      </Tooltip>

                      <Menu
                        anchorEl={anchorEl}
                        open={openUserMenu}
                        onClose={handleUserMenuClose}
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "right",
                        }}
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "right",
                        }}
                      >
                        <MenuItem onClick={handleLogout}>התנתקות</MenuItem>
                      </Menu>
                    </>
                  ) : (
                    <Tooltip title="התחברות">
                      <IconButton color="inherit" component={Link} to="/signIn">
                        <PersonIcon style={{ fontSize: 36, color: "#58A76B" }} />
                      </IconButton>
                    </Tooltip>
                  )}

                  <Box
  onMouseEnter={(e) => {
    setCartAnchor(e.currentTarget);
    setShowCartPreview(true);
  }}
  onMouseLeave={() => {
    setShowCartPreview(false);
  }}
>
  <Tooltip title="עגלת קניות">
    <IconButton
      color="inherit"
      onClick={() => {
        setShowCartPreview(false);
        setCartAnchor(null);
        navigate("/cart");
      }}
    >
      <CartIcon />
    </IconButton>
  </Tooltip>

  <Popper
    open={showCartPreview}
    anchorEl={cartAnchor}
    placement="bottom-start"
    sx={{ zIndex: 99999 }}
  >
    <Box
      onMouseEnter={() => setShowCartPreview(true)}
      onMouseLeave={() => setShowCartPreview(false)}
      sx={{ mt: 1 }}
    >
      <CartHoverPreview cart={cart || []} />
    </Box>
  </Popper>
</Box>
                </Box>
              </Toolbar>
            </Paper>
          </Box>
        </Container>
      </AppBar>
    </>
  );
}

